export default __webpack_public_path__ + "static/20_19-5e5fc0dc661c5037abfefc257feb78c0.png";